import React from 'react';

const PaymentForm = ({
  paymentMethod,
  setPaymentMethod,
  employees,
  selectedEmployee,
  setSelectedEmployee,
  services,
  searchTerm,
  setSearchTerm,
  selectedServicesByEmployee,
  setSelectedServicesByEmployee,
  paymentMethods
}) => {
  // Manejo de selección de empleado
  const handleEmployeeSelection = (e) => {
    const selected = employees.find(emp => emp.empleado_id === e.target.value);
    setSelectedEmployee(selected);
  };

  // Selección de servicios
  const handleServiceSelection = (service) => {
    if (!selectedEmployee) return;
    setSelectedServicesByEmployee(prev => {
      const current = prev[selectedEmployee.empleado_id] || [];
      const exists = current.find(s => s.servicio_id === service.servicio_id);
      if (exists) {
        return {
          ...prev,
          [selectedEmployee.empleado_id]: current.map(s =>
            s.servicio_id === service.servicio_id ? { ...s, count: s.count + 1 } : s
          )
        };
      } else {
        return {
          ...prev,
          [selectedEmployee.empleado_id]: [
            ...current,
            { ...service, count: 1, empleado_id: selectedEmployee.empleado_id }
          ]
        };
      }
    });
  };

  // Deselección de servicios
  const handleServiceDeselection = (service) => {
    if (!selectedEmployee) return;
    setSelectedServicesByEmployee(prev => {
      const current = prev[selectedEmployee.empleado_id] || [];
      const exists = current.find(s => s.servicio_id === service.servicio_id);
      if (exists && exists.count > 1) {
        return {
          ...prev,
          [selectedEmployee.empleado_id]: current.map(s =>
            s.servicio_id === service.servicio_id ? { ...s, count: s.count - 1 } : s
          )
        };
      } else {
        return {
          ...prev,
          [selectedEmployee.empleado_id]: current.filter(s => s.servicio_id !== service.servicio_id)
        };
      }
    });
  };

  // Filtrar y ordenar servicios según el término de búsqueda
  const filteredServices = services.filter(service =>
    service.nombre.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const sortedServices = filteredServices.sort((a, b) => {
    const aSelected = (selectedServicesByEmployee[selectedEmployee?.empleado_id] || []).find(s => s.servicio_id === a.servicio_id);
    const bSelected = (selectedServicesByEmployee[selectedEmployee?.empleado_id] || []).find(s => s.servicio_id === b.servicio_id);
    return (bSelected ? 1 : 0) - (aSelected ? 1 : 0);
  });

  return (
    <div className="space-y-4">
      {/* Método de Pago */}
      <div>
        <label className="block mb-2 text-sm font-bold text-gray-700">Método de Pago</label>
        <select
          className="w-full p-2 border rounded"
          value={paymentMethod}
          onChange={(e) => setPaymentMethod(e.target.value)}
        >
          {paymentMethods.map((method) => (
            <option key={method.metodo_id} value={method.nombre}>
              {method.nombre}
            </option>
          ))}
        </select>
      </div>

      {/* Selección de Empleado */}
      <div>
        <label className="block mb-2 text-sm font-bold text-gray-700">Empleado</label>
        <select
          className="w-full p-2 border rounded"
          value={selectedEmployee ? selectedEmployee.empleado_id : ''}
          onChange={handleEmployeeSelection}
        >
          <option value="" disabled>
            Seleccione un empleado
          </option>
          {employees.map((employee) => (
            <option key={employee.empleado_id} value={employee.empleado_id}>
              {employee.nombre}
            </option>
          ))}
        </select>
      </div>

      {/* Búsqueda de Servicios */}
      <div>
        <label className="block mb-2 text-sm font-bold text-gray-700">Buscar Servicios</label>
        <input
          type="text"
          className="w-full p-2 border rounded"
          placeholder="Buscar..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Selección de Servicios */}
      <div className="max-h-48 overflow-y-auto">
        <label className="block mb-2 text-sm font-bold text-gray-700">Selecciona Servicios</label>
        {sortedServices.map((service) => (
          <div
            key={service.servicio_id}
            className={`flex items-center justify-between mb-2 p-2 border rounded ${
              selectedServicesByEmployee[selectedEmployee?.empleado_id]?.some(s => s.servicio_id === service.servicio_id)
                ? 'bg-blue-100'
                : 'bg-gray-100'
            }`}
          >
            <div>
              <span>{service.nombre} - ${service.precio}</span>
            </div>
            <div className="flex items-center space-x-2">
              {selectedServicesByEmployee[selectedEmployee?.empleado_id]?.find(s => s.servicio_id === service.servicio_id)?.count > 0 && (
                <button
                  className="px-2 py-1 bg-red-500 text-white rounded"
                  onClick={() => handleServiceDeselection(service)}
                >
                  -
                </button>
              )}
              <span>
                {selectedServicesByEmployee[selectedEmployee?.empleado_id]?.find(s => s.servicio_id === service.servicio_id)?.count || 0}
              </span>
              <button
                className="px-2 py-1 bg-blue-500 text-white rounded"
                onClick={() => handleServiceSelection(service)}
              >
                +
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentForm;
